import { getEncodedParams } from 'helpers/encodeParams';

exports.semKeywordSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/sem/keyword/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.semAdgroupSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/sem/adgroup/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.semCampaignSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/sem/campaign/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.semConversionSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/sem/conversion/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};



// WEBPACK FOOTER //
// ./src/services/sem/selectors.js